import { render } from "./logout.vue?vue&type=template&id=5c834838&scoped=true"
import script from "./logout.vue?vue&type=script&lang=ts"
export * from "./logout.vue?vue&type=script&lang=ts"

import "./logout.vue?vue&type=style&index=0&id=5c834838&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c834838"

export default script